<!-- <div>{{'CONNECTION STATE: '+(connectionState() | json)}}</div>
<div>{{'PAYMENT STATE: '+(paymentState() | json)}}</div> 
<div>{{'LOADING: '+ loading()}}</div>
<div>{{'MOBILE: '+ isMobile()}}</div> -->

<div class="web3-confirmation">
  <h2 class="mb-4">{{ 'web3_confirm_title' | translate }}</h2>

  <!-- Error -->
  @if (paymentState().error) {
    <c-alert color="danger" dismissible class="mb-4">
      <strong>{{ 'web3_error_prefix' | translate }}</strong> {{ paymentState().error }}
    </c-alert>
  }
  <c-card class="mb-4 shadow-sm">
    <c-card-body>
      <h5 class="mb-3">{{ 'web3_wallet_connection' | translate }}</h5>
      @if (!connectionState().connected) {
        <!-- QR / Connect Options -->
        <div class="text-center">
          @if (connectionState().walletConnectUri; as uri) {
            @if (qrCodeConnection()) {
              <div class="qr-code-container mx-auto mb-4 p-4 rounded shadow">
                <p class="mb-3 fw-bold">{{ 'web3_scan_qr' | translate }}</p>
                <qrcode
                  [qrdata]="connectionState().walletConnectUri!"
                  [width]="256"
                  [errorCorrectionLevel]="'M'"
                  [margin]="4"
                  cssClass="qr-code border border-4 border-white rounded shadow"
                ></qrcode>
                <c-alert color="warning" class="mt-4 text-start small">
                  <strong>{{ 'web3_scan_instruction' | translate }}</strong>
                  <ul class="mb-0 mt-2 ps-3">
                    <li>{{ 'web3_scan_instruction_trust' | translate }}</li>
                    <li>{{ 'web3_scan_instruction_exodus' | translate }}</li>
                    <li>{{ 'web3_scan_instruction_metamask' | translate }}</li>
                  </ul>
                </c-alert>
              </div>
            } @else {
              <div>
                <p class="mb-3 fw-bold">{{ 'web3_connect_mobile_wallet' | translate }}</p>
                <button
                  cButton
                  color="primary"
                  size="lg"
                  class="mb-3 w-100"
                  (click)="openWalletConnectUri(uri)"
                >
                  <svg cIcon name="cilWallet" class="me-2"></svg>
                  {{ 'web3_open_wallet_app' | translate }}
                </button>
                <p class="text-body-secondary small">
                  {{ 'web3_mobile_instruction' | translate }}
                </p>
                <button
                  cButton
                  color="secondary"
                  size="sm"
                  (click)="copyWalletConnectUri()"
                >
                  <svg cIcon name="cilCopy" class="me-2"></svg>
                  {{ 'web3_copy_uri' | translate }}
                </button>
              </div>
            }
            <!--
            @if (isMobile()) {
              < !-- Mobile deep-link -- >
                <button
                cButton
                color="primary"
                size="lg"
                class="mb-3 w-100"
                (click)="openWalletConnectUri(uri)"
              >
                <svg cIcon name="cilWallet" class="me-2"></svg>
                {{ 'web3_open_wallet_app' | translate }}
              </button>
              <p class="text-body-secondary small">
                {{ 'web3_mobile_instruction' | translate }}
              </p>
              <button
                cButton
                color="secondary"
                size="sm"
                (click)="copyWalletConnectUri()"
              >
                <svg cIcon name="cilCopy" class="me-2"></svg>
                {{ 'web3_copy_uri' | translate }}
              </button>
            } @else {
              < !-- Desktop QR -- >
              <div class="qr-code-container mx-auto mb-4 p-4 rounded shadow">
                <p class="mb-3 fw-bold">{{ 'web3_scan_qr' | translate }}</p>
                <qrcode
                  [qrdata]="connectionState().walletConnectUri!"
                  [width]="256"
                  [errorCorrectionLevel]="'M'"
                  [margin]="4"
                  cssClass="qr-code border border-4 border-white rounded shadow"
                ></qrcode>
                <c-alert color="warning" class="mt-4 text-start small">
                  <strong>{{ 'web3_scan_instruction' | translate }}</strong>
                  <ul class="mb-0 mt-2 ps-3">
                    <li>{{ 'web3_scan_instruction_trust' | translate }}</li>
                    <li>{{ 'web3_scan_instruction_exodus' | translate }}</li>
                    <li>{{ 'web3_scan_instruction_metamask' | translate }}</li>
                  </ul>
                </c-alert>
              </div>
            }
          -->
          } @else {
            <c-alert color="info" class="mb-5 small">
              <p class="fs-5 mb-2">{{ 'web3_connect_wallet' | translate }}</p>
              <svg cIcon name="cilInfo" class="me-1"></svg>
              {{ 'web3_wallet_compatibility_warning' | translate }}
            </c-alert>

            <button
              cButton
              color="primary"
              size="lg"
              class="w-100 mb-2"
              [disabled]="loading()"
              (click)="connectWallet(false)"
            >
              @if (loading()) {
                <c-spinner size="sm" class="me-2"></c-spinner>
                <span translate="web3_connecting"></span>
              } @else {
                <svg cIcon name="cilWallet" class="me-2"></svg>
                <span translate="web3_connect_browser_wallet"></span>
              }
              <!-- {{ loading() ? ('web3_connecting' | translate) : ('web3_connect_browser_wallet' | translate) }} -->
            </button>
            <p class="text-body-secondary small mb-4">
              {{ 'web3_browser_wallet_desc' | translate }}
            </p>

            <button
              cButton
              [color]="'secondary'"
              size="lg"
              class="w-100 mb-2"
              [disabled]="loading()"
              (click)="connectWallet(true)"
            >
              @if (loading()) {
                <c-spinner size="sm" class="me-2"></c-spinner>
                <span translate="web3_connecting"></span>
              } @else {
                <svg cIcon name="cilQrCode" class="me-2"></svg>
                <span translate="web3_connect_qr_code"></span>
              }
              <!-- {{ loading() ? ('web3_connecting' | translate) : ('web3_connect_qr_code' | translate) }} -->
            </button>
            <p class="text-body-secondary small mb-0">
              {{ 'web3_qr_code_desc' | translate }}
            </p>
            <!--
            @if (hasBrowserWallet()) {
              <button
                cButton
                color="primary"
                size="lg"
                class="w-100 mb-2"
                [disabled]="loading()"
                (click)="connectWallet(false)"
              >
                @if (loading()) {
                  <c-spinner size="sm" class="me-2"></c-spinner>
                } @else {
                  <svg cIcon name="cilWallet" class="me-2"></svg>
                }
                {{ loading() ? ('web3_connecting' | translate) : ('web3_connect_browser_wallet' | translate) }}
              </button>
              <p class="text-body-secondary small mb-4">
                {{ 'web3_browser_wallet_desc' | translate }}
              </p>
            }

            <button
              cButton
              [color]="hasBrowserWallet() ? 'secondary' : 'primary'"
              size="lg"
              class="w-100 mb-2"
              [disabled]="loading()"
              (click)="connectWallet(true)"
            >
              @if (loading()) {
                <c-spinner size="sm" class="me-2"></c-spinner>
                <span translate="web3_connecting"></span>
              } @else {
                @if (isMobile()) {
                  <svg cIcon name="cryptoWallet" class="me-2"></svg>
                  <span translate="web3_connect_button"></span>
                } @else {
                  <svg cIcon name="cilQrCode" class="me-2"></svg>
                  <span translate="web3_connect_qr_code"></span>
                } 
              }
              < !-- {{ loading() ? ('web3_connecting' | translate) : ('web3_connect_qr_code' | translate) }} -- >
            </button>
            @if (!isMobile()) {
              <p class="text-body-secondary small mb-0">
                {{ 'web3_qr_code_desc' | translate }}
              </p>
            }
          -->
          }
        </div>
      } @else {
        <!-- Connected Info -->
        <div class="connected-info p-3 text-white rounded">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-success">
              <svg cIcon name="cilCheckAlt" class="me-2"></svg>
              {{ 'web3_wallet_connected' | translate }}
            </span>
            <button
              cButton
              color="danger"
              size="sm"
              (click)="disconnectWallet()"
            >
              {{ 'web3_disconnect' | translate }}
            </button>
          </div>

          <p class="mb-2 small">
            <strong>{{ 'web3_address' | translate }}</strong>
            {{ shortenAddress(connectionState().address) }}
          </p>
          <p class="mb-2 small">
            <strong>{{ 'web3_network' | translate }}</strong>
            {{ getNetworkName() }}
          </p>
          <p class="mb-0 small">
            <strong>{{ 'web3_token_balance' | translate: { token: selectedToken() } }}</strong>
            {{ tokenBalance() || '0' }} {{ selectedToken() }}
          </p>

          @if (!isCorrectNetwork()) {
            <c-alert color="warning" class="mt-3">
              {{ 'web3_switch_network' | translate }}
              <button
                cButton
                color="warning"
                size="sm"
                class="ms-2"
                (click)="switchNetwork()"
              >
                {{ 'web3_switch_button' | translate }}
              </button>
            </c-alert>
          }
        </div>
      }
    </c-card-body>
  </c-card>

  <!-- Payment Details -->
  @if (connectionState().connected && isCorrectNetwork()) {
    <c-card class="mb-4 shadow-sm">
      <c-card-body>
        <h5 class="mb-3">{{ 'web3_payment_details' | translate }}</h5>

        <!-- Token selector: which BSC stablecoin to pay in -->
        <div class="mb-3">
          <p class="mb-2 small text-body-secondary">{{ 'web3_select_token' | translate }}</p>
          <div class="btn-group w-100" role="group">
            @for (t of tokenOptions; track t) {
              <button
                cButton
                [color]="selectedToken() === t ? 'primary' : 'outline-primary'"
                [active]="selectedToken() === t"
                [disabled]="tokenLocked()"
                (click)="selectToken(t)"
              >
                {{ t }}
              </button>
            }
          </div>
        </div>

        <c-row>
          <c-col sm="6">
            <p class="mb-1 small text-body-secondary">{{ 'web3_order_id' | translate }}</p>
            <p class="fw-bold">#{{ orderId }}</p>
          </c-col>
          <c-col sm="6">
            <p class="mb-1 small text-body-secondary">{{ 'web3_amount' | translate }}</p>
            <p class="fw-bold">{{ totalPrice | localeNumber: '1.2-2' }} {{ selectedToken() }}</p>
          </c-col>
        </c-row>

        @if (!hasSufficientBalance() && tokenBalance()) {
          <c-alert color="danger" class="mt-3">
            {{ 'web3_insufficient_balance' | translate: { required: totalPrice | localeNumber: '1.2-2', available: tokenBalance(), token: selectedToken() } }}
          </c-alert>
        }

        <button
          cButton
          color="primary"
          class="w-100 mt-4"
          [disabled]="!canSendPayment()"
          (click)="sendPayment()"
        >
          @if (loading()) {
            <c-spinner size="sm" class="me-2"></c-spinner>
          }
          {{ paymentButtonText() }}
        </button>
      </c-card-body>
    </c-card>
  }

  <!-- Transaction Progress -->
  @if (paymentState().transactionHash) {
    <c-card class="mb-4 shadow-sm">
      <c-card-body>
        <h5 class="mb-3">{{ 'web3_transaction_progress' | translate }}</h5>

        <p class="mb-2 small text-body-secondary">{{ 'web3_transaction_hash' | translate }}</p>
        <p class="text-break mb-3"><code>{{ paymentState().transactionHash }}</code></p>

        <a
          [href]="'https://bscscan.com/tx/' + paymentState().transactionHash"
          target="_blank"
          cButton
          color="outline-primary"
          size="sm"
        >
          {{ 'web3_view_bscscan' | translate }}
          <svg cIcon name="cilExternalLink" size="sm" class="ms-1"></svg>
        </a>

        @if (paymentState().step === 'confirming') {
          <div class="mt-4">
            <div class="d-flex justify-content-between mb-2">
              <span>{{ 'web3_confirmations' | translate }}</span>
              <strong>{{ paymentState().confirmations }} / {{ paymentState().requiredConfirmations }}</strong>
            </div>
            <c-progress>
              <c-progress-bar
                [value]="confirmationProgress()"
                [color]="progressColor()"
              ></c-progress-bar>
            </c-progress>
            <p class="text-center text-body-secondary mt-3 small">
              <c-spinner size="sm" class="me-2"></c-spinner>
              {{ 'web3_waiting_confirmations' | translate }}
            </p>
          </div>
        }

        @if (paymentState().step === 'completed') {
          <c-alert color="success" class="mt-4">
            <svg cIcon name="cilCheckAlt" class="me-2"></svg>
            {{ 'web3_payment_confirmed' | translate }}
          </c-alert>
        }
      </c-card-body>
    </c-card>
  }

  <!-- Status Message -->
  @if (paymentState().message && !paymentState().error) {
    <c-alert color="info" class="mt-4">
      {{ paymentState().message }}
    </c-alert>
  }

  <!-- Back Button -->
  <div class="mt-4">
    <button
      cButton
      color="secondary"
      [disabled]="loading() || ['sending', 'confirming'].includes(paymentState().step)"
      (click)="onBack.emit()"
    >
      <svg cIcon name="cilArrowLeft" size="lg" class="me-2"></svg>
      {{ 'web3_back' | translate }}
    </button>
  </div>
</div>